import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import "./chefListScreen.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  API_TEST,
  PREP_TIME,
  S3_MENU_FOLDER,
  S3_MENU_THUMBNAIL_FOLDER,
} from "../../store/constants";
import { getTodayDateValue, secondShiftApplies } from "../../utils/timeHelper";
import moment from "moment";
import { menuActions } from "../../store/menuSlice";
import { bottomBarActions } from "../../store/bottomBarSlice";
import "video.js/dist/video-js.css";
import CustomVideoPlayer from "../CustomVideoPlayer/Index";
import ChefCardSkeleton from "./ChefCardSkeleton";
import ContentLoader from "react-content-loader";
import ClockIconSvg from "../../assets/ReactSvg/ClockIconSvg";
import StarIconSvg from "../../assets/ReactSvg/StarIconSvg";
import ExpandIconSvg from "../../assets/ReactSvg/ExpandIconSvg";
import { Collapse, Modal } from "antd";
import NonVegIconSvg from "../../assets/ReactSvg/NonVegSvgIcon";
import VegIconSvg from "../../assets/ReactSvg/VegSvgIcon";
import RightIconSvg from "../../assets/ReactSvg/RightIconSvg";
import classNames from "classnames";
import BackFilledSvgIcon from "../../assets/ReactSvg/BackFilledSvgIcon";
import ChefOfflineBottomModal from "./ChefOfflineBottomModal";
import ChefLockIconSvg from "../../assets/ReactSvg/ChefLockIconSvg";
import ThankYouPopupIconSvg from "../../assets/ReactSvg/ThankYouPopupIconSvg";
import { toast } from "react-toastify";
import axios from "axios";
import { chefActions } from "../../store/chefSlice";
import ChefCardDailyDishCard from "./ChefCardDailyDishCard";
import { getUsersChefInterest } from "../../store/chefActions";
import FiveStar from "../../assets/images/Badges/5Star.svg";
import TenYearsFB from "../../assets/images/Badges/10YearsFB.svg";
import TWENTYFIVEYearsMiddleEast from "../../assets/images/Badges/25YearsMiddleEast.svg";
import CruiseLineChef from "../../assets/images/Badges/CruiseLineChef.svg";
import FineDiningExperience from "../../assets/images/Badges/FineDiningExperience.svg";
import IHMGraduate from "../../assets/images/Badges/IHMGraduate.svg";
import MainlandChina from "../../assets/images/Badges/MainlandChina.svg";
import SelfMadeChef from "../../assets/images/Badges/SelfMadeChef.svg";
import Trainedjapan from "../../assets/images/Badges/Trainedjapan.svg";
import VerifiedIconSvg from "../../assets/ReactSvg/VerifiedIconSvg";
import PremiumExpIconSvg from "../../assets/ReactSvg/PremiumExpIconSvg";
import GourmetIconSvg from "../../assets/ReactSvg/GourmetIconSvg";

const STATIC_CURATOR_NAME = "Trupti";

const STATIC_EXPERIENCE_TYPES = [
  { label: "Premium", icon: PremiumExpIconSvg },
  { label: "Gourmet", icon: GourmetIconSvg },
];

const ChefCardComponent = ({ chef, isChefMainScreen, chefVideo, isRoundedDesign }) => {
  const { experienceType } = chef || {};
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.chef.categories);
  const kitchensList = useSelector((state) => state.chef.kitchensList);
  const chefId = chef?._id;
  const userId = useSelector(({ auth }) => auth.user.userid);
  const [windowWidth, setWindowWidth] = useState(
    Math.min(window.innerWidth - 30, 550 - 30)
  );
  const [isReady, setIsReady] = useState(false);
  const [isChefOfflineModalOpen, setIsChefOfflineModalOpen] = useState(false);
  const [isVideoReadyToPlay, setIsVideoReadyToPlay] = useState(false);
  const [isFirstMediaLoaded, setIsFirstMediaLoaded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const deliveryDetails = useSelector(({ auth }) => auth.deliveryDetails);
  const isServiceable = useSelector((state) => state.auth.isServiceable);
  const chefCategoriesList = categories[chefId] || [];
  const kitchenId = chef?.kitchenId || "";
  const kitchenInfo = kitchensList.find((k) => k._id === kitchenId);
  const interestedChef = useSelector((state) => state.chef.interestedChef);
  const dailySpecialDishes =
    chefCategoriesList?.find((chef) => chef.type === "daily")?.dishes || [];
  const weeklySpecialDishes =
    chefCategoriesList?.find((chef) => chef.type === "weekly")?.dishes || [];
  const dailySpecialCatId =
    chefCategoriesList?.find((chef) => chef.type === "daily")?._id || "";
  const weeklySpecialCatId =
    chefCategoriesList?.find((chef) => chef.type === "weekly")?._id || "";

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(Math.min(window.innerWidth - 30, 550 - 30));
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const showModal = async () => {
    setLoading(true);
    const apiUrl = `${API_TEST}add_chef_interest`;
    if (!userId) {
      toast.error("Please log in to express your interest in this chef!");
      setLoading(false);
      return;
    }
    const body = { chefId, userId };
    try {
      const response = await axios.post(apiUrl, body);
      const responseValue = response.data;
      if (responseValue.statusCode === 200) {
        dispatch(getUsersChefInterest(userId));
        setIsModalOpen(true);
        setTimeout(() => {
          handleClose();
        }, 2000);
      }
    } catch (error) {
      toast.error("Failed to add in interested");
    }
    setLoading(false);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const onSpecialDishClick = (catId) => {
    if (isChefCommingSoon) return;
    const chefId = chef._id;
    dispatch(menuActions.setCurrentChefIdClicked(chefId));
    dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
    dispatch(bottomBarActions.updateFrom({ from: "dishesScreen" }));
    dispatch(chefActions.onMenuCategorieId(catId));
  };

  const onChefClick = (chefInfo) => {
    if (isChefCommingSoon) return;
    const chefId = chefInfo._id;
    dispatch(menuActions.setCurrentChefIdClicked(chefId));
    dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
  };

  const onCuratorClick = () => {
    dispatch(bottomBarActions.loadTab({ tabName: "curatorScreen" }));
  };

  const handleMenuClick = () => {
    dispatch(menuActions.setIsMenuClicked(true));
    dispatch(bottomBarActions.loadTab({ tabName: "menu" }));
    dispatch(chefActions.onMenuClick(chefId));
    dispatch(bottomBarActions.updateFrom({ from: "explore" }));
    dispatch(chefActions.onMenuCategorieId(chefId));
    // mixpanel.track("go-to-menu-clicked");
    // clevertap.event.push("go-to-menu-clicked");
  };


  // const onHostClick = () => {
  //   dispatch(bottomBarActions.loadTab({ tabName: "hostScreen" }));
  // };

  const todayChefSchedule = getTodayDateValue(chef?.schedules);
  const chefDeliveryDetails = deliveryDetails[kitchenId] || {};
  const delivery_distance = chefDeliveryDetails?.delivery_distance;
  const deliveryDistanceInKMS = Math.round(delivery_distance / 1000);

  const getChefDistance = () => {
    return `${deliveryDistanceInKMS}km`;
  };

  const getStatusLabel = (chefInfo) => {
    const { isSwitchOff, chefWaitTime, schedules = [], kitchenId } = chefInfo;
    const chefDeliveryDetails = deliveryDetails[kitchenId] || {};
    const delivery_distance = chefDeliveryDetails?.delivery_distance;
    const delivery_duration = chefDeliveryDetails?.delivery_duration?.value;
    let delivery_Time = delivery_duration
      ? Math.round(delivery_duration / 60)
      : 10;

    const chefWaitTimeValue = Math.max(PREP_TIME, chefWaitTime || 0);
    const todayChefSchedule = getTodayDateValue(schedules);

    if (!isServiceable) {
      return "Pre-bookings only";
    } else if (isSwitchOff) {
      return "offline";
    } else if (!todayChefSchedule?.isAvailable) {
      const findNextDayIndex = schedules.findIndex(
        (s) => s._id === todayChefSchedule._id
      );
      if (findNextDayIndex === schedules.length - 1) {
        const nextDayInfo = schedules[0];
        const startTime = nextDayInfo?.startTime || nextDayInfo?.startTime1;
        return `Opens tomorrow at ${startTime}`;
      } else {
        const nextDayInfo = schedules[findNextDayIndex + 1];
        const startTime = nextDayInfo?.startTime || nextDayInfo?.startTime1;
        return `Opens tomorrow at ${startTime}`;
      }
    } else if (todayChefSchedule?.online) {
      if (delivery_duration) {
        return `${delivery_Time + chefWaitTimeValue} min`;
      } else {
        return "Open now";
      }
    } else if (todayChefSchedule?.isAvailable) {
      if (
        secondShiftApplies(todayChefSchedule) &&
        todayChefSchedule?.startTime1 &&
        todayChefSchedule?.endTime1
      ) {
        return `Opens at ${moment(
          todayChefSchedule?.startTime1,
          "h:mm A"
        ).format("h a")}`;
      }
      return `Opens at ${moment(todayChefSchedule?.startTime, "h:mm A").format(
        "h a"
      )}`;
    }
  };

  const getStatusClassname = (todayChefSchedule) => {
    if (!isServiceable) {
      return "chef-non-serviciable";
    } else if (todayChefSchedule?.online) {
      return "chef-online";
    } else {
      return "chef-away";
    }
  };

  const cuisineList = chef?.cuisine?.split(",").map((c) => c.trim()) || [];
  const servingLabel = `Serving ${cuisineList.join(" & ")}`

  const renderImage = (imageName) => {
    switch (imageName) {
      case "5-Star Hotel Veteran":
        return FiveStar;
      case "Trained in Japan":
        return Trainedjapan;
      case "IHM Graduate":
        return IHMGraduate;
      case "Cruise Line Chef":
        return CruiseLineChef;
      case "20+ Years Experience":
        return "";
      case "Self-Made Chef":
        return SelfMadeChef;
      case "Indo-Chinese Expert":
        return "";
      case "Fine Dining Experience":
        return FineDiningExperience;
      case "10+ Years F&B":
        return TenYearsFB;
      case "Mainland China Alumni":
        return MainlandChina;
      case "25 Years in Middle East":
        return TWENTYFIVEYearsMiddleEast;
      case "Dubai-Trained Team":
        return "";
      case "Chef Entrepreneur":
        return "";
      case "6 Years Community Chef":
        return "";
      case "Advertising pro turned chef":
        return "";
      case "Marketing Graduate turned chef":
        return "";
      case "Tandoor Specialist":
        return "";
      case "Mainland China Trained":
        return "";
      case "Mumbai Veteran":
        return "";
      case "Le Cordon Bleu Graduate":
        return "";
      case "Indigo Trained":
        return "";

      default:
        break;
    }
  };

  const getItems = () => [
    {
      key: "1",
      label: <span className="chefInfoListLabel Satoshi">Story</span>,
      children: (
        <p>
          <ul key={1} className="chefInfoWrapperDescriptionListWrapper Satoshi">
            {chef?.label1 && <span>{`${chef?.label1}`}</span>}
            {chef?.label2 && <span>{`${chef?.label2}`}</span>}
            {chef?.label3 && <span>{`${chef?.label3}`}</span>}
          </ul>
        </p>
      ),
      style: {
        border: "none",
      },
    },
  ];

  const chefBadgeList = chef?.chefBadge || [];

  const ChefDetailInfoWrapper = () => (
    <div
      className={classNames("chefDetailInfoWrapper", {
        chefDetailInfoWrapperRounded: isRoundedDesign,
      })}
    >
      <div
        className={classNames({
          chefCardContentSections: isRoundedDesign,
        })}
        style={{ width: "100%" }}
      >
        {!isRoundedDesign && <div className="chefNameContainerWrapper">
          <div className="chefInfoWrapper">
            <div
              style={isChefCommingSoon ? { filter: "blur(4px)" } : {}}
              className={`chef-name-light chef-name-label-wrapper Satoshi`}
            >
              <span
                className={`status-dot ${getStatusClassname(
                  todayChefSchedule
                )}`}
              ></span>
              <div className="chef-name-container">{chef.name}</div>
            </div>
            <div className="d-flex" style={{ flexDirection: "column" }}>
              <div className="d-flex align-items-center">
                <StarIconSvg />
                <span
                  style={{ marginLeft: 3 }}
                  className="successRateLabel Satoshi"
                >
                  {chef.successRate || "100"}
                </span>
                <span
                  style={{ fontSize: 12 }}
                  className="successRateLabel Satoshi"
                >
                  %
                </span>
              </div>
              <div className="chefDishesServedLabel Satoshi">
                {chef.dishes} Dishes served
              </div>
            </div>
          </div>
          <div style={{ marginTop: 4 }} className="chefInfoWrapper">
            <div className="chefSpecialityLabelWrapper">
              {chefBadgeList.map((text, index) => (
                <div key={index} className="ribbon-tag">
                  {text}
                </div>
              ))}
            </div>
          </div>
          {/* {isChefMainScreen && (
            <div
              className="transparentBtn filterTransparentBtn Satoshi viewHostBtn"
              onClick={onHostClick}
            >
              View Host
            </div>
          )} */}
        </div>}
        {/* {!isChefMainScreen &&
          (chef?.label1 || chef?.label2 || chef?.label3) && (
            <div
              style={{ marginTop: 4 }}
              className="chefInfoWrapperDescription"
            >
              <Collapse
                bordered={false}
                // defaultActiveKey={["1"]}
                expandIconPosition="end"
                className="chefLabelDescriptionCollapse"
                expandIcon={({ isActive }) => (
                  <ExpandIconSvg rotate={isActive ? 90 : 0} />
                )}
                style={{ background: "#fff" }}
                items={getItems()}
              />
            </div>
          )} */}
        {!!dailySpecialDishes.length && (
          <>
            {!isRoundedDesign && <div className="dailySpecialDishesWrapper">
              {dailySpecialDishes.map((dish, index) => (
                <React.Fragment key={index}>
                  <ChefCardDailyDishCard
                    index={index}
                    onSpecialDishClick={onSpecialDishClick}
                    dailySpecialCatId={dailySpecialCatId}
                    dish={dish}
                    dailySpecialDishes={dailySpecialDishes}
                  />
                </React.Fragment>
              ))}
            </div>}
          </>
        )}
        {isRoundedDesign && (
          <div className="chefCardDetailsSection">
            <div className="chefCardNameRow">
              <div className="chefCardNameLabelWrapper">
                <div className="chefCardNameLabel Satoshi">{chef.name}</div>
                <VerifiedIconSvg size={20} />
              </div>
            </div>
            <div className="chefCardMetaRow Satoshi">
              <div className="chefCardMetaItem">
                <span className="chefCardMetaLabel">Curated by</span>
                <span
                  className="chefCardMetaCurator"
                  onClick={onCuratorClick}
                >
                  {STATIC_CURATOR_NAME}
                </span>
              </div>
              {!isNaN(deliveryDistanceInKMS) && (
                <>
                  <span className="chefCardMetaDot" />
                  <span className="chefCardMetaValue">{getChefDistance()}</span>
                </>
              )}
              <span className="chefCardMetaDot" />
              <span className="chefCardMetaValue">{deliveryTimeLabel}</span>
            </div>
          </div>
        )}
        {!isChefMainScreen && !!weeklySpecialDishes.length && (
          isRoundedDesign ? (
            <div className="chefCardServingSection">
              <div className="weeklySpecialLabel Satoshi">{servingCuisinesLabel}</div>
              <div className="weeklySpecialDishesWrapper">
                {weeklySpecialDishes.map((dish, index) => (
                  <div
                    key={index}
                    className="weeklySpecialDishesContainer"
                    onClick={() => onSpecialDishClick(weeklySpecialCatId)}
                  >
                    <div className="weeklySpecialDishImageWrapper">
                      <span className="weeklySpecialDishType">
                        {dish.type === "veg" ? <VegIconSvg /> : <NonVegIconSvg />}
                      </span>
                      <img
                        className="weeklySpecialDishImage"
                        src={dish.img ? S3_MENU_THUMBNAIL_FOLDER + dish.img : ""}
                        alt="Dish image"
                      />
                    </div>
                    <span className="weeklySpecialDishName Satoshi">
                      {dish.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <>
              <div className="weeklySpecialLabel Satoshi">Weekly Special</div>
              <div className="weeklySpecialDishesWrapper">
                {weeklySpecialDishes.map((dish, index) => (
                  <div
                    key={index}
                    className="weeklySpecialDishesContainer"
                    onClick={() => onSpecialDishClick(weeklySpecialCatId)}
                  >
                    <div className="weeklySpecialDishImageWrapper">
                      <span className="weeklySpecialDishType">
                        {dish.type === "veg" ? <VegIconSvg /> : <NonVegIconSvg />}
                      </span>
                      <img
                        className="weeklySpecialDishImage"
                        src={dish.img ? S3_MENU_THUMBNAIL_FOLDER + dish.img : ""}
                        alt="Dish image"
                      />
                    </div>
                    <span className="weeklySpecialDishName Satoshi">
                      {dish.name}
                    </span>
                  </div>
                ))}
              </div>
            </>
          )
        )}

        <section style={{ padding: "0px 16px" }} className="hostExpertSection">
          <h2 className="hostExpertSectionTitle Satoshi">{servingLabel}</h2>
          <div className="hostExpertDishesRow">
            {chefCategories.filter((cat) => !!cat.img).map((category, index) => (
              <div
                key={index}
                className="hostExpertDishItem"
                onClick={() => chefId && onChefClick?.(chefId)}
                role="button"
                tabIndex={0}
              >
                <div className="hostExpertDishImageWrapper">
                  <span className="hostExpertDishType">
                    {/* {category.type === "veg" ? <VegIconSvg /> : <NonVegIconSvg />} */}
                  </span>
                  {category.img ? (
                    <img
                      className="hostExpertDishImage"
                      src={
                        category.img.includes("amazonaws.com")
                          ? category.img
                          : S3_MENU_THUMBNAIL_FOLDER + category.img
                      }
                      alt={category.name}
                    />
                  ) : (
                    <div className="hostExpertDishImagePlaceholder" />
                  )}
                </div>
                <span className="hostExpertDishName Satoshi">{category.name}</span>
              </div>
            ))}
          </div>
        </section>


        {!isChefMainScreen && !isChefCommingSoon && !isRoundedDesign && (
          <button
            className="exploreMenuLabel Satoshi transparentBtn"
          >
            {`Explore menu`} <RightIconSvg />
          </button>
        )}
        {isRoundedDesign ? (
          <div className="chefCardExperienceSection" onClick={handleMenuClick} >
            <div className="chefCardExploreLabel Satoshi">Experience type</div>
            <div className="chefCardExperienceRow">
              {STATIC_EXPERIENCE_TYPES.map(({ label, icon: Icon }, index) => (
                <div key={label} className="chefCardExperienceItem">
                  <Icon size={20} />
                  <span className="chefCardExperienceText Satoshi">{experienceType[index]}</span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div>
            <div className="chefCardExploreLabel Satoshi">Experience type</div>
            <ul className="chefCardExploreList Satoshi">
              <li>Gourmet</li>
              <li>Premium</li>
            </ul>
          </div>
        )}
        {isChefCommingSoon && (
          <button
            disabled={loading || interestedChef.includes(chef._id)}
            className="chefInteresttedBtn Satoshi"
            onClick={() => showModal()}
          >
            {interestedChef.includes(chef._id)
              ? "You're interested"
              : "I am interested!"}
          </button>
        )}
      </div>
    </div>
  );

  const switchTab = (tabName) => {
    dispatch(bottomBarActions.loadTab({ tabName: tabName }));
  };

  const onBackClick = () => {
    switchTab("chef");
  };

  const chefCategories = categories[chef._id] || [];
  const cardImages = [chef.profileImg];
  const dishesArrayOfArray = chefCategories
    ?.map((d) => d?.dishes?.length)
    ?.map((category) =>
      category.dishes?.map((dish) => dish.stories?.map((story) => story.img))
    );
  const storyArray = [].concat.apply([], dishesArrayOfArray);
  const dishArrayImages = [].concat
    .apply([], storyArray)
    .map((img) => S3_MENU_FOLDER + img);
  const cardImagesArray = [...cardImages, ...dishArrayImages];
  const slicecardImagesArray = cardImagesArray.slice(0, 1) || [];

  const onChange = () => { };

  const onClickItem = () => { };

  const onClickThumb = () => { };

  const handleFirstMediaLoad = () => {
    setIsFirstMediaLoaded(true);
  };

  const chefVideoUrl = S3_MENU_FOLDER + chefVideo;
  console.log('chefCategories :>> ', chefCategories);
  // const CarouselArray = chefVideoUrl && !isChefMainScreen ? [chefVideoUrl, ...slicecardImagesArray] : [...slicecardImagesArray];
  const CarouselArray = [...slicecardImagesArray, ...slicecardImagesArray];

  const onChefVideoReady = () => {
    setIsReady(true);
  };

  useEffect(() => {
    onChefVideoReady();
  }, []);

  const handleSetIsVideoReadyToPlay = (value) => {
    // if(videoLoadedIndex <= chefCardComponentIndex){
    //     setVideoLoadedIndex(chefCardComponentIndex + 1);
    // }
    // setIsVideoReadyToPlay(value);
  };
  useEffect(() => {
    // if (isChefMainScreen) {
    //     handleSetIsVideoReadyToPlay(true)
    // }
    if (true) {
      handleSetIsVideoReadyToPlay(true);
    }
  }, [isChefMainScreen]);

  const allCuisineList = chef?.cuisine?.split(",") || [];
  const isChefCommingSoon = false; // !kitchenInfo?.restID;
  const chefQuote = chef?.label1;
  const servingCuisinesLabel = `Serving ${allCuisineList.map((cuisine) => cuisine.trim()).join(" & ")}`
  const deliveryTimeLabel = getStatusLabel(chef);

  return (
    <>
      {/* {!isVideoReadyToPlay && <ChefCardSkeleton />} */}
      <div
        style={!isChefMainScreen ? { marginBottom: 15 } : {}}
      // className={`chefCardWrapper ${isVideoReadyToPlay ? "show" : "hide"}`}
      >
        <div
          className={classNames({
            chefCardMainScreen: isChefMainScreen,
            chefCardWrapperContainer: !isChefMainScreen,
            chefCardWrapperContainerRound: isRoundedDesign,
          })}
          onClick={(e) => {
            if (isChefMainScreen) return;
            if (e.target.closest('.chefCardMetaItem')) return;
            const rect = e.currentTarget.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            if (x < 2 || x > rect.width - 2 || y < 2 || y > rect.height - 2) return;
            onChefClick(chef);
          }}
        >
          <div className="carouselOverlayContentWrapper">
            <div
              style={
                isChefCommingSoon ? { filter: "blur(4px) brightness(0.7)" } : {}
              }
            >

              {!isFirstMediaLoaded && <div className="carousel-skeleton-overlay">
                <ContentLoader
                  viewBox="0 0 400 390"
                  height={isRoundedDesign ? "100%" : 390}
                  width="100%"
                  backgroundColor="#f0f0f0"
                  foregroundColor="#e0e0e0"
                >
                  <rect x="0" y="0" rx={isRoundedDesign ? 16 : 0} ry={isRoundedDesign ? 16 : 0} width="400" height="390" />
                </ContentLoader>
              </div>}

              <div className={`chefCardWrapper ${isFirstMediaLoaded ? "show" : "hide"}`} >
                <Carousel
                  preventMovementUntilSwipeScrollTolerance={true}
                  showArrows={false}
                  showThumbs={false}
                  showStatus={false}
                  showIndicators={isRoundedDesign}
                  swipeScrollTolerance={10}
                  className={classNames("slider-custom-carousel", {
                    "slider-custom-carousel-rounded": isRoundedDesign,
                  })}
                  onChange={onChange}
                  destroyCarousel
                  onClickItem={onClickItem}
                  onClickThumb={onClickThumb}
                >
                  {chef.cardImage.map(({ image: img, headline }, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        // onChefClick(chef)
                      }}
                      style={{ position: "relative" }}
                    >
                      {/* {!isFirstMediaLoaded && index === 0 && (
                      <div className="carousel-skeleton-overlay">
                        <ContentLoader
                          viewBox="0 0 400 220"
                          height={isRoundedDesign ? "100%" : 220}
                          width="100%"
                          backgroundColor="#f0f0f0"
                          foregroundColor="#e0e0e0"
                        >
                          <rect x="0" y="0" rx={isRoundedDesign ? 16 : 0} ry={isRoundedDesign ? 16 : 0} width="400" height="220" />
                        </ContentLoader>
                      </div>
                    )} */}
                      {img.includes(".mp4") ? (
                        <div className="carousel-react-player">
                          <CustomVideoPlayer
                            videoUrl={img}
                            height={220}
                            onReady={() => {
                              onChefVideoReady();
                              if (index === 0) handleFirstMediaLoad();
                            }}
                            index={index}
                            handleSetIsVideoReadyToPlay={
                              handleSetIsVideoReadyToPlay
                            }
                          />
                          <div
                            // onClick={() => onChefClick(chef)}
                            className="chefPhotoClickDiv"
                          ></div>
                        </div>
                      ) : (
                        <img
                          style={
                            isRoundedDesign
                              ? { objectFit: "cover", height: "100%" }
                              : { objectFit: "cover", maxHeight: 400 }
                          }
                          alt=""
                          src={
                            img.includes("amazonaws.com")
                              ? img
                              : S3_MENU_THUMBNAIL_FOLDER + img
                          }
                          onLoad={index === 0 ? handleFirstMediaLoad : undefined}
                        />
                      )}

                      <div
                        style={isChefCommingSoon ? { filter: "blur(4px)" } : {}}
                        className="chefCardImageOverlay"
                      >
                        <p className="chefCardQuote Satoshi">{headline}</p>
                        <div className="chefCardOverlayBottom">
                        </div>
                      </div>

                    </div>
                  ))}
                </Carousel>
              </div>

            </div>
            {isChefMainScreen && (
              <div className="carouselTopBackbtn" onClick={onBackClick}>
                <BackFilledSvgIcon />
              </div>
            )}
            {!isRoundedDesign && <div
              style={isChefCommingSoon ? { filter: "blur(4px)" } : {}}
              className={`carouselOverlayContent`}
            >
              {allCuisineList?.map((cuisine, index) => (
                <span
                  key={index}
                  className="carouselOverlayCuisineName Satoshi"
                >
                  {cuisine?.trim()}
                </span>
              ))}
            </div>}
            {!isRoundedDesign && <div className="carouselOverlayContentRight">
              <div
                className="flex-container"
                onClick={() => setIsChefOfflineModalOpen(true)}
              >
                <span>
                  <ClockIconSvg />
                </span>
                <span className={`status-label-light status-label Satoshi`}>
                  {getStatusLabel(chef)}
                </span>
                {!isNaN(deliveryDistanceInKMS) && (
                  <span
                    className={`distance-label-light distance-label Satoshi`}
                  >
                    {getChefDistance(chef)}
                  </span>
                )}
              </div>
            </div>}
            {isChefCommingSoon && (
              <div className="chefCarouselOverlayCommingSoonWrapper">
                <div className="chefCarouselOverlayCommingSoonBox">
                  <ChefLockIconSvg />
                  <div className="chefCarouselOverlayCommingSoonDesc Satoshi">
                    This Chef's details are currently locked. Choose 'I am
                    interested!' to be alerted about updates.
                  </div>
                </div>
              </div>
            )}
            {isRoundedDesign && (
              <div
                style={isChefCommingSoon ? { filter: "blur(4px)" } : {}}
                className="chefCardImageOverlay transparent-bg"
              >
                {/* <p className="chefCardQuote Satoshi">{chefQuote}</p> */}
                <div className="chefCardOverlayBottom">
                  <span className="chefCardPrice Satoshi">
                    {chef.cost}
                  </span>
                </div>
              </div>
            )}
          </div>
          <ChefDetailInfoWrapper />
        </div>
      </div>
      <ChefOfflineBottomModal
        isOpen={isChefOfflineModalOpen}
        setOpen={setIsChefOfflineModalOpen}
      />
      <Modal
        className="hideTopBarAndBottomBar"
        wrapClassName="hideTopBarAndBottomBarWrapper"
        centered
        title="Basic Modal"
        open={isModalOpen}
      >
        <ThankYouPopupIconSvg />
      </Modal>
    </>
  );
};

export default ChefCardComponent;
